import * as React from 'react';

import * as styles from './ChatMessageChatbotGreeting.css';
import { ChatMessageLayout, TChatMessageLayoutProps } from '../ChatMessageLayout';

type TChatMessageChatbotGreeting = Pick<
  TChatMessageLayoutProps,
  'messageUserId' | 'isLastInChain' | 'created' | 'textNode' | 'imagesNode'
>;

export const ChatMessageChatbotGreeting = ({
  messageUserId,
  isLastInChain,
  created,
  textNode,
  imagesNode,
}: TChatMessageChatbotGreeting) => {
  return (
    <ChatMessageLayout
      messageUserId={messageUserId}
      isOutcoming={false}
      isUnread={false}
      isOnlyImage={false}
      isOffer={true}
      isLastInChain={isLastInChain}
      isTextAndImage={false}
      created={created}
      imagesNode={imagesNode}
      textNode={<div className={styles['text']}>{textNode}</div>}
      actionButtonsNode={null}
      statusNode={null}
      errorSignNode={null}
      errorTextNode={null}
      errorMenuNode={null}
      infoMessageNode={null}
      documentNode={null}
      imageAsDocumentNode={null}
      offerNode={null}
      likesNode={null}
      bubblesNode={null}
    />
  );
};
